import React from 'react';
import Icon from "./Icon";

export default ({onClick}) => {
    return (
        <div>
            <button className="btn btn-link back-btn"
                    onClick={() => onClick && onClick()}>
                <span className="h4 mr-2"><Icon.ArrowLeft/></span>
                Back
            </button>
        </div>
    );
}
